<template>
    <main id="liste" v-cloak>
        <HeaderTab :title="$t('menu.congelation.facturation')" :swiper_tabs="swiper_tabs" />

        <div id="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>


<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js";

	export default {
		name: "Congelation",
		mixins: [Navigation],
		data () {
			return {
            }
		},
        computed: {
            swiper_tabs() {
                return [{
                    id: 'exp_non_facture',
                    label: 'monte.congelation.exp_non_facture',
                    active: false,
                    href : 'CongelationExpeditionLivresInvoice',
                },
                {
                    id: 'last_congelation',
                    label: 'monte.congelation.last_congelation',
                    active: false,
                    href : 'CongelationLastCongelation',
                }]
            },
        },
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
		}
	}
</script>
